<template>
  <div class="mixtmt_pagination_box">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pnum"
      :page-sizes="pageSizes"
      :page-size="psize"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <div class="pagination-select_box">
      <el-select
        v-model="selectPageSize"
        :popper-append-to-body="false"
        placeholder="请选择"
        @change="handleSizeChange"
        v-if="pageSizes && pageSizes.length > 0"
      >
        <el-option
          v-for="item in pageSizes"
          :key="item"
          :label="`${item}条/页`"
          :value="item"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MixtmtPagination',
  props: {
    pageSizes: {
      type: Array,
      default: () => {
        return []
      },
    },
    total: {
      type: Number,
      default: 30,
    },
    psize: {
      type: Number,
      default: 10,
    },
    pnum: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      selectPageSize: null,
    }
  },
  created() {
    this.selectPageSize = this.psize
  },
  methods: {
    handleSizeChange(val) {
      //   console.debug(`每页 ${val} 条`)
      this.$emit('SizeChange', val)
    },
    handleCurrentChange(val) {
      //   console.debug(`当前页: ${val}`)
      this.$emit('CurrentChange', val)
    },
  },
}
</script>

<style lang="scss">
.mixtmt_pagination_box {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  align-items: center;
  .pagination-select_box {
    width: 6.94vw;
    .el-input {
      font-size: 0.972vw;
    }
    .el-input--suffix {
      .el-input__inner {
        padding-right: 2.083vw;
        height: 1.944vw;
        line-height: 1.944vw;
        padding: 0 1.0416vw;
        border-radius: 0.208vw;
      }
      .el-input__suffix {
        right: 0;
      }
    }
    .el-select-dropdown {
      .el-select-dropdown__item {
        font-size: 0.972vw;
        padding: 0 1.388vw;
        height: 2.361vw;
        line-height: 2.361vw;
      }

      .el-select-dropdown__item.selected,
      .el-select-dropdown__item.hover,
      .el-select-dropdown__item.active,
      .el-select-dropdown__item.visited {
        color: var(--mixtmt_subColor1_1);
        background-color: var(--mixtmt_subColor1_2);
      }
    }

    .el-range-editor.is-active,
    .el-range-editor.is-active:hover,
    .el-select .el-input.is-focus .el-input__inner {
      border-color: var(--mixtmt_mainColor6);
    }
  }
  .el-pagination button,
  .el-pagination span:not([class*='suffix']) {
    font-size: 0.9027vw;
    height: 1.944vw;
    line-height: 1.944vw;
    min-width: 2.5vw;
  }
  .el-pagination__jump {
    margin-left: 1.667vw;
  }

  .el-input--mini .el-input__inner {
    line-height: 1.944vw;
    height: 1.944vw;
  }

  .el-pagination__sizes .el-input .el-input__inner {
    font-size: 0.9027vw;
  }

  .el-pager li {
    font-size: 0.9027vw;
    height: 1.944vw;
    line-height: 1.944vw;
  }

  .el-pagination__editor {
    line-height: 1.25vw;
    height: 1.944vw;
    font-size: 0.972vw;

    &.el-input {
      width: 3.472vw;
    }
  }

  .el-pagination__editor.el-input .el-input__inner {
    height: 1.944vw;
    font-size: 0.972vw;
    border-radius: 0.208vw;
  }

  .el-pagination .el-select .el-input {
    width: 6.94vw;
  }

  .el-pagination .el-select .el-input .el-input__inner {
    padding-right: 2.083vw;
  }

  .el-input__icon {
    width: 2.083vw;
  }

  .el-select .el-input .el-select__caret {
    font-size: 0.972vw;
    line-height: 1.944vw;
  }

  .el-select-dropdown__list {
    padding: 0.416vw 0;
  }

  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: var(--mixtmt_mainColor6);
  }
  .el-pagination button:hover {
    color: var(--mixtmt_mainColor6);
  }
}
</style>
